import React from 'react';
import PropTypes from 'prop-types';
import DateCustomFieldValue from '../../CustomFieldValues/components/DateCustomFieldValue';
import GenericCustomFieldValue from '../../CustomFieldValues/components/GenericCustomFieldValue';
import TextAreaCustomFieldValue from '../../CustomFieldValues/components/TextAreaCustomFieldValue';

const ANSWER_INPUTS = {
  'CustomFieldValues::Date': DateCustomFieldValue,
  'CustomFieldValues::TextArea': TextAreaCustomFieldValue,
};

export default function PassQuestions({ quantity, answersForPass, onAnswerChange }) {
  return (
    <div className="series-pass-questions" data-testid="series-pass-questions">
      {Array.from({ length: quantity }, (_, passIndex) => (
        <div
          key={passIndex}
          className="series-pass-question-group"
          data-testid={`series-pass-questions-${passIndex}`}
        >
          <div className="series-pass-question-heading">Pass {passIndex + 1}</div>
          {answersForPass(passIndex).map((customFieldValue) => {
            const AnswerInput = ANSWER_INPUTS[customFieldValue.type] || GenericCustomFieldValue;

            return (
              <AnswerInput
                key={customFieldValue.custom_field.id}
                customFieldValue={customFieldValue}
                customFieldValueChanged={(updated) => onAnswerChange(passIndex, updated)}
                idSuffix={`pass-${passIndex}`}
              />
            );
          })}
        </div>
      ))}
    </div>
  );
}

PassQuestions.propTypes = {
  quantity: PropTypes.number.isRequired,
  answersForPass: PropTypes.func.isRequired,
  onAnswerChange: PropTypes.func.isRequired,
};
